import { TypeGuards, useCallback, useMemo, useModal, useState } from '@codeleap/common'

export function useModalWithProps<T extends Record<string, any>>(initialProps: T | (() => T), visible?: boolean) {
  const modal = useModal(visible)

  const getInitialProps = useCallback(() => {
    if (TypeGuards.isFunction(initialProps)) {
      return initialProps()
    }
    return initialProps
  }, [])

  const [currentProps, setProps] = useState(getInitialProps)

  const resetProps = () => {
    setProps(getInitialProps())
  }

  const toggle = (toValue?: boolean, props?: T) => {
    const nextState = toValue ?? !modal.visible

    if (nextState) {
      setProps(props)
    } else {
      resetProps()
    }

    modal.toggle(toValue)
  }

  return {
    visible: modal.visible,
    props: currentProps,
    toggle,
    resetProps,
    setProps,
  }
}
